import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Container, Row, Col, Card, Table, ListGroup } from 'react-bootstrap';
import { ArrowLeftCircle, CheckCircle, Cart } from 'react-bootstrap-icons';
import axios from 'axios';
import { API } from '../../../api/URL_API';
import { useTiendaConfig } from '../../../hooks/useTiendaConfig';
import getIcon from '../../../utils/getIcon';
import Loader from './componenetes/Loader';
import { useNavigate } from 'react-router-dom';
import icon from '../../../utils/rmc.png';

function ViewPedido() {
    const { numPedido } = useParams();
    const { socialLinks } = useTiendaConfig();
    const [pedido, setPedido] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPedido = async () => {
            try {
                const response = await axios.get(`${API}/api/verpedidos/carrito/${numPedido}`);
                setPedido(response.data);
                //console.log('Datos del pedido obtenidos:', response.data);
            } catch (error) {
                console.error('Error al obtener los datos del pedido:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchPedido();
    }, [numPedido]);

    const redirectToRoot = () => {
        navigate(`/`);
    };

    if (loading) return <div className="text-center"><Loader /></div>;
    if (!pedido || !pedido.productos || pedido.productos.length === 0) return <div>No hay productos en este pedido.</div>;

    const totalItems = pedido.productos.reduce((acc, item) => acc + item.cantidad, 0);
    const totalProductos = pedido.productos.reduce((acc, item) => acc + item.subtotal, 0);

    const formatCop = (value) => value?.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }) || '$0';

    return (
        <>
            <Container className="my-4">
                {/* Encabezado */}
                <header className="mb-4">
                    <Row className="align-items-center text-center flex-column flex-md-row">
                        <Col xs={12} md={4} className="text-center mb-2 mb-md-0">
                            <div className="mt-4 text-center text-md-start">
                                {socialLinks.map((link, index) => (
                                    <a key={index} href={link.url} target='_blank' rel="noopener noreferrer" title={link.title}>
                                        <Button variant='link' className='text-danger fs-4 mx-2'>
                                            {getIcon(link.url)}
                                        </Button>
                                    </a>
                                ))}
                            </div>
                            {/* Botón de Volver */}
                            <div className="mt-4 text-center text-md-start mb-4 mb-md-0">
                                <Button
                                    variant="danger"
                                    className="d-inline-flex align-items-center"
                                    onClick={redirectToRoot}
                                >
                                    <ArrowLeftCircle className="me-2" size={20} /> Volver a Catálogo
                                </Button>
                            </div>
                        </Col>
                        <Col xs={12} md={8} className="text-center">
                            <img src={icon} alt="reymidascaps" width="150" className="img-fluid" />
                        </Col>
                    </Row>
                </header>

                <Row>
                    {/* Información General */}
                    <Col md={6} xs={12} className="mb-4">
                        <Card className="shadow-sm">
                            <Card.Header className="bg-black text-white text-center fw-bold">
                                <CheckCircle className="me-2 text-success" size={20} /> Información General
                            </Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item>
                                    <strong>Número de Pedido:</strong> <span className="text-danger">{pedido.numPedido}</span>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <strong>Fecha:</strong> {new Date(pedido.creacion).toLocaleDateString()}
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <strong>Subtotal:</strong> {formatCop(totalProductos)}
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <strong>Descuento:</strong> {pedido.descuento} %
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <strong>Items Totales:</strong> {totalItems}
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <strong>Costo de Envío:</strong> {formatCop(pedido.costoEnvio)}
                                </ListGroup.Item>
                                <ListGroup.Item className="border-top">
                                    <strong>Total del Pedido:</strong>
                                    <span className="fw-bold fs-5 text-danger ms-2">{formatCop(pedido.totalPedido)}</span>
                                </ListGroup.Item>
                            </ListGroup>
                        </Card>
                    </Col>

                    {/* Resumen del Pedido */}
                    <Col md={6} xs={12}>
                        <Card className="shadow-sm">
                            <Card.Header className="bg-black text-white text-center fw-bold">
                                <Cart className="me-2 text-danger" size={20} /> Resumen del Pedido
                            </Card.Header>
                            <Card.Body>
                                <Table responsive hover className="text-center">
                                    <thead>
                                        <tr>
                                            <th>Producto</th>
                                            <th>Precio</th>
                                            <th>Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pedido.productos.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="d-flex align-items-start">
                                                        <img
                                                            src={item.imgProducto}
                                                            alt="Producto"
                                                            width="60"
                                                            height="60"
                                                            className="rounded border me-2"
                                                        />
                                                        <div className="text-start">
                                                            <div className='text-black fw-bold'>{item.nomProducto}</div>
                                                            {item.nomCategoria && (
                                                                <div className="text-muted small">{item.nomCategoria}</div>
                                                            )}
                                                            <div className="text-black fw-bold" style={{ fontSize: "0.85rem" }}>
                                                                Cant: {item.cantidad}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>{formatCop(item.precioU)}</td>                                                <td>{formatCop(item.subtotal)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ViewPedido;
